module.exports = __webpack_public_path__ + "img/hand.b6448fa6.svg";